// extracted by mini-css-extract-plugin
export default {"RandomReveal":"RandomReveal_RandomReveal__04bGX","spin":"RandomReveal_spin__49s8u"};